<template>
  <div class="home">
    <h1 class="big-title t-orange">BATTLE GAME</h1>
    <router-link :to="{ name: 'Play' }">
      <button class="play-btn bg-orange">Play</button>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>
